import { useState } from "react";

import "./WorksheetSearchBar.css";

const WorksheetSearchBar = ({
  handleFilter,
  placeholder = "학습지명 검색",
}) => {
  const [keyword, setKeyword] = useState("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleFilter(keyword);
    }
  };

  return (
    <div className="worksheet-search-bar">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        className="worksheet-search-bar__icon"
        onClick={() => handleFilter(keyword)}
      >
        <circle cx="11" cy="11" r="7" />
        <line x1="16.5" y1="16.5" x2="21" y2="21" />
      </svg>
      <input
        type="text"
        className="worksheet-search-bar__input"
        placeholder={placeholder}
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default WorksheetSearchBar;
